import React from 'react'
import createReactClass from 'create-react-class'
import i18n from 'live/services/i18n'
import xhr from 'live/services/xhr'

var StatsBase = require('live/components/extensions/ui/stats')

var View = createReactClass({
    getInitialState() {
        return {
            instance: {}
        }
    },
    UNSAFE_componentWillMount() {
        this.fetch(this.props.id)
    },
    UNSAFE_componentWillReceiveProps(newProps) {
        var id = newProps.id
        var currentId = this.props.id

        if (id != currentId) this.fetch(id)
    },
    fetch(id) {
        xhr.get('/rest/extension/' + id).then(this.setInstance)
    },
    setInstance(resp) {
        this.setState({
            instance: resp.data
        })
    },
    render() {
        var instance = this.state.instance
        var info = [
            {
                label: i18n('Output URL'),
                value: instance.config && instance.config.endpoint
            }
        ]

        return <StatsBase {...this.props} noFetch={true} instance={instance} info={info} />
    }
})

module.exports = View
